import Line from "./textLine";

function Card({ id, name, flag, population, region, capital, onClick }) {
  return (
    <div className="card" onClick={onClick} id={id}>
      <div className="card-img">
        <img src={flag} alt={`${name} Flag Image`} />
      </div>

      <div className="card-container">
        <h2>{name}</h2>
        <div className="card-content flex">
          <Line title="Population" content={population} />
          <Line title="Region" content={region} />
          <Line title="Capital" content={capital} />
        </div>
      </div>
    </div>
  );
}

export default Card;
